import { useEffect, useState } from "react";
import { Input, Button } from "antd";
import { SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import PartnerCard from "@/components/PartnerCard";
import { orpcClient } from "@/lib/orpc-client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function CoopReviewedManagement() {
  const { t } = useTranslation();
  const [coopData, setCoopData] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleBackToList = () => {
    navigate("/hrMainPage/coop");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await orpcClient.partner.list({});
        const filtered = (result ?? []).filter(
          (p: any) => p?.status === "disabled"
        );
        setCoopData(filtered);
      } catch (error) {
        console.error("Error fetching partner data:", error);
      }
    };

    fetchData();
  }, []);

  const matchesSearch = (item: any) => {
    const keyword = searchQuery.trim().toLowerCase();
    if (!keyword) return true;
    return (
      item?.name?.toLowerCase().includes(keyword) ||
      item?.businessIdNumber?.toLowerCase().includes(keyword) ||
      item?.contacts?.some((c: any) =>
        c?.name?.toLowerCase().includes(keyword)
      )
    );
  };

  const filteredData = coopData.filter(matchesSearch);

  if (!coopData || coopData.length === 0) {
    return (
      <div className="flex min-h-screen items-center justify-center p-8">
        <div className="w-[487px] rounded-xl bg-white px-16 py-20 shadow-sm">
          <div className="text-center" style={{ color: "#6F6F6F" }}>
            {t("coop.noReviewedData") || "您尚未有已停用的資料"}
          </div>
          <div className="flex text-center">
            <Button
              type="default"
              style={{ width: "100%", margin: "1rem" }}
              onClick={handleBackToList}
            >
              {t("coop.backToPartnerList") || "回到合作方列表"}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: 16,
        backgroundColor: "#fff",
        margin: "16px 16px 0",
        borderRadius: "0.75rem",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <Input
            prefix={<SearchOutlined style={{ color: "#999" }} />}
            placeholder={t("coop.searchPlaceholder")}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ maxWidth: 360 }}
            allowClear
          />
          <Button icon={<ArrowLeftOutlined />} onClick={handleBackToList}>
            {t("coop.backToPartnerList") || "回到合作方列表"}
          </Button>
        </div>

        <div>
          <div
            style={{
              fontWeight: 600,
              fontSize: 14,
              marginBottom: 12,
              color: "#555",
            }}
          >
            {t("coop.reviewedManagement") || "已停用合作方"}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredData.map((partner) => (
              <PartnerCard
                key={partner.id}
                partner={partner}
                onClick={() => navigate(`/hrMainPage/coop/${partner.id}`)}
                variant="disabled"
              />
            ))}
          </div>
          {filteredData.length === 0 && (
            <div style={{ textAlign: "center", padding: "48px 0", color: "#999" }}>
              {t("coop.noResults") || "找不到符合條件的合作方"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CoopReviewedManagement;
